import { Button } from '@platform/components';

export const ContinueButton = () => {
  return (
    <Button variant='primary' size='lg' type='submit' additionalClassnames='w-full'>
      Continue
    </Button>
  );
};
